var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{
    'text-success':_vm.connectedToServer,
    'text-danger':!_vm.connectedToServer},attrs:{"title":"Server connection status"}},[_c('i',{staticClass:"fas fa-circle"})])}
var staticRenderFns = []

export { render, staticRenderFns }